<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="green"
          title="Simple Table"
          text="Here is a subtitle for this table"
        >
          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.phone }}</td>
              <td class="text-xs-right">{{ item.YTD }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
      <v-flex
        md12
      >
        <material-card
          color="green"
          flat
          full-width
          title="Table on Plain Background"
          text="Here is a subtitle for this table"
        >
          <v-data-table
            :headers="headers"
            :items="items.slice(0, 7)"
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.phone }}</td>
              <td class="text-xs-right">{{ item.YTD }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    headers: [
      {
        sortable: false,
        text: 'Name',
        value: 'name'
      },
      {
        sortable: false,
        text: 'email',
        value: 'email'
      },
      {
        sortable: false,
        text: 'phone',
        value: 'phone'
      },
      {
        sortable: false,
        text: 'YTD',
        value: 'YTD',
        align: 'right'
      }
    ],
    items: [
      {
        name: 'Dakota Rice',
        email: 'Niger',
        phone: 'Oud-Tunrhout',
        YTD: '$35,738'
      },
      {
        name: 'Minerva Hooper',
        email: 'Curaçao',
        phone: 'Sinaai-Waas',
        YTD: '$23,738'
      }, {
        name: 'Sage Rodriguez',
        email: 'Netherlands',
        phone: 'Overland Park',
        YTD: '$56,142'
      }, {
        name: 'Philip Chanley',
        email: 'Korea, South',
        phone: 'Gloucester',
        YTD: '$38,735'
      }, {
        name: 'Doris Greene',
        email: 'Malawi',
        phone: 'Feldkirchen in Kārnten',
        YTD: '$63,542'
      }, {
        name: 'Mason Porter',
        email: 'Chile',
        phone: 'Gloucester',
        YTD: '$78,615'
      }
    ]
  })
}
</script>
